module.exports = __webpack_public_path__ + "img/homeIcon_1.4a08388f.png";